export const STATUS_CLIENTE_ATIVO = 'A';

export const MINIMO_PALAVRAS_JUSTIFICATIVA = 3;
export const MAX_LENGTH_NUM_PROCESSO = 11;
export const MAX_COUNTER_JUSTIFICATIVA = 500;

export const RECALCULAR_VALOR_OPTIONS = [
  { id: 'N', value: 'Não' },
  { id: 'S', value: 'Sim' },
];

export const TITULO_PAGINA = 'Alterar Código do Cliente de um processo';
export const SUBTITULO_PAGINA = 'Informe o Processo que deseja alterar o Código do Cliente.';
export const LABEL_NUMERO_PROCESSO = 'Número do Processo:';
export const LABEL_CODIGO_CLIENTE = 'Código do Cliente';
export const LABEL_RAZAO_SOCIAL_NOME = 'Razão Social/Nome';
export const LABEL_NOVO_CODIGO_CLIENTE = 'Novo Código do Cliente*';
export const LABEL_RECALCULAR_PROCESSO = 'Recalcular processo?';
export const LABEL_JUSTIFICATIVA = 'Justificativa*';
export const LABEL_CONSULTAR = 'Consultar';
export const LABEL_ALTERAR = 'Alterar';

export const MENSAGEM_ERRO_BUSCA_PROCESSO = 'Nenhum resultado foi encontrado relacionado à sua pesquisa';
export const MENSAGEM_ERRO_BUSCA_CLIENTE_NOVO = 'Nenhum resultado foi encontrado relacionado à sua pesquisa';
export const MENSAGEM_ERRO_VERIFICAR_PAGAMENTO = 'Não foi possível verificar se o processo possui pagamentos recebidos. Tente novamente.';
export const MENSAGEM_BLOQUEIO_PAGAMENTO = 'Não é possível alterar o código do cliente de um processo com pagamentos recebidos.';
export const MENSAGEM_SUCESSO_ALTERACAO = 'Código do cliente alterado com sucesso.';
export const MENSAGEM_ERRO_ALTERACAO = 'Não foi possível realizar a alteração do código do cliente para este processo.';
export const MENSAGEM_CONFIRMACAO_ALTERACAO = 'O código do cliente deste processo será alterado. Deseja continuar?';
export const MENSAGEM_ERRO_JUSTIFICATIVA = 'Informe pelo menos 3 palavras';
export const MENSAGEM_ERRO_HISTORICO_AUTOMATICO = 'Cliente alterado, mas não foi possível registrar o histórico automático desta alteração.';
